import { RegisterContext } from './RegisterContext'
import { useEffect, useMemo, useState } from 'react'
import { sweetError } from '@/utils/sweetalert2'
import { countriesAsync } from '@/services/axios/guest/general'

export const RegisterProvider = ({ children }) => {
  const [selects, setSelects] = useState({
    countries: []
  })
  const [loading, setLoading] = useState({
    countries: true
  })
  const [placeholder, setPlaceholder] = useState({
    phonenumber: 'Ingrese teléfono',
    trade: 'Ingrese nombre'
  })

  useEffect(() => {
    const getCountrySelection = async () => {
      try {
        const { data: { records: countries } } = await countriesAsync()
        setSelects(prevState => ({
          ...prevState,
          countries
        }))
        setLoading(prevState => ({
          ...prevState,
          countries: false
        }))
      } catch (e) {
        sweetError('', e)
      }
    }
    getCountrySelection()
  }, [])

  const onChange = useMemo(() => {
    const onCountryChange = (data) => {
      const { value: { area_code: areaCode } } = data
      setPlaceholder(prevState => ({
        ...prevState,
        phonenumber: areaCode
      }))
    }
    return { onCountryChange }
  }, [])

  const props = useMemo(() => ({
    selects,
    onChange,
    loading,
    placeholder
  }), [loading, onChange, placeholder, selects])

  return (
    <RegisterContext.Provider value={props}>
      {children}
    </RegisterContext.Provider>
  )
}
